import { ChevronsUpDown, LogOut, UserRound } from "lucide-react";

import { Avatar } from "@/components/ui/avatar";
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem, useSidebar } from "@/components/ui/sidebar";
import { Dropdown } from "@/components/dropdown";
import { Link } from "@tanstack/react-router";

export function SidebarNavUser({
  user,
}: {
  user: {
    username: string;
    displayName: string;
  };
}) {
  const { isMobile } = useSidebar();

  const dropdownItems = [
    {
      id: "user-info",
      label: (
        <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
          <Avatar className="size-8 rounded-fill bg-muted items-center justify-center m-2">
            <UserRound />
          </Avatar>
          <div className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg grid  text-left leading-tight ">
            {user.displayName && user.displayName.length > 0 ? (
              <>
                <span className="truncate font-semibold ">{user.displayName}</span>
                <span className="truncate text-xs ">{user.username} </span>
              </>
            ) : (
              <span className="truncate font-semibold">{user.username}</span>
            )}
          </div>
        </div>
      ),
      isLabel: true,
    },
    {
      id: "separator",
      isSeparator: true,
    },
    {
      id: "logout",
      label: (
        <Link to="/logout" className="flex flex-1 items-center gap-2">
          <LogOut />
          <span>Log out</span>
        </Link>
      ),
    },
  ];

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <Dropdown
          trigger={
            <SidebarMenuButton
              size="lg"
              className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
            >
              <Avatar className="size-8 rounded-full bg-muted items-center justify-center">
                <UserRound />
              </Avatar>
              <div className="grid flex-1 text-left text-sm leading-tight">
                {user.displayName && user.displayName.length > 0 ? (
                  <>
                    <span className="truncate font-semibold">{user.displayName}</span>
                    <span className="truncate text-xs">{user.username}</span>
                  </>
                ) : (
                  <span className="truncate font-semibold">{user.username}</span>
                )}
              </div>
              <ChevronsUpDown className="ml-auto size-4" />
            </SidebarMenuButton>
          }
          items={dropdownItems.map((item) => {
            if (item.isLabel) {
              return {
                id: item.id,
                label: item.label,
                isLabel: true,
              };
            }
            if (item.isSeparator) {
              return {
                id: item.id,
                isSeparator: true,
              };
            }
            return item;
          })}
          align="end"
          side={isMobile ? "bottom" : "right"}
        />
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
